import { useContext } from "react";
import { VenueContext } from "@/context/VenueContext";

export const useVenueDetail = () => useContext(VenueContext);
